var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgSupport(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 42.5H2v28a8 8 0 008 8h59.5c4.418 0 8-3.584 8-8.003V42.5zM75 12v30.5H5V12a4 4 0 014-4h62a4 4 0 014 4z",
    stroke: "#504FE9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42.5v-8.261c0-.44.291-.82.695-.993 5.403-2.306 5.568-10.567.496-12.848-.586-.263-1.191.216-1.191.86v4.328a1 1 0 01-.293.707l-1.5 1.5a1 1 0 01-1.414 0l-1.5-1.5a1 1 0 01-.293-.707v-4.329c0-.643-.605-1.122-1.191-.859-5.072 2.281-4.907 10.542.496 12.848.404.172.695.554.695.993V42.5M33.5 8V4a2 2 0 012-2h9a2 2 0 012 2v4M57.5 42.5v10m10-10v10m0 0v4a1 1 0 01-1 1h-8a1 1 0 01-1-1v-4m10 0h-10M46 42.5V49a1 1 0 01-1 1H34.5a1 1 0 01-1-1v-6.5M12.5 42.5v10m10-10v10m0 0v5h-10v-5m10 0h-10M35 42.5v-6h2.5m7.5 6v-6h-2.5m0 0v-8.723a1 1 0 01.142-.515l1.215-2.024a1 1 0 00.143-.515V21a1 1 0 00-1-1h-6a1 1 0 00-1 1v3.723a1 1 0 00.142.515l1.215 2.024a1 1 0 01.143.515V36.5m5 0h-5M55 42.5V34c-5.5-2.5-8-11 0-14v6l2.5 3 2.5-3v-6c8 3 5.5 11.5 0 14v8.5",
    stroke: "#504FE9",
    strokeWidth: 2
  })));
}
export default SvgSupport;